interface ErrorFallbackProps {
  error?: unknown;
  resetError?: () => void;
}

export default function ErrorFallback({ resetError }: ErrorFallbackProps) {
  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 16,
        padding: 32,
        fontFamily: 'var(--font-family-inter, system-ui, sans-serif)',
        background: 'var(--background, #fff)',
        color: 'var(--foreground, #111)',
      }}
    >
      <h1 style={{ fontSize: 22, fontWeight: 600, margin: 0 }}>Algo deu errado</h1>
      <p style={{ maxWidth: 480, textAlign: 'center', margin: 0, opacity: 0.8 }}>
        Encontramos um erro inesperado. Nossa equipe foi notificada automaticamente.
        Tente recarregar a página.
      </p>
      <button
        onClick={() => {
          resetError?.();
          window.location.reload();
        }}
        style={{
          padding: '10px 20px',
          borderRadius: 8,
          border: '1px solid var(--border, #ddd)',
          background: 'var(--primary, #2563eb)',
          color: 'var(--primary-foreground, #fff)',
          cursor: 'pointer',
          fontSize: 14,
          fontWeight: 500,
        }}
      >
        Recarregar página
      </button>
    </div>
  );
}
